// English texts of the "html" area. Keys start with "html."
export default {
  // Update banner (its message is set by interfaces/classic/ui/update-manager.js)
  "html.update.refresh": "Refresh Now",

  // Profile screen
  "html.profile.back": "Back to app",
  "html.profile.title": "Profile",
  "html.profile.account": "Account",
  "html.profile.username": "Username",
  "html.profile.memberSince": "Member since",
  "html.profile.email": "Email",
  "html.profile.status": "Status",
  "html.profile.resendVerification": "Resend Verification",
  "html.profile.security": "Security",
  "html.profile.password": "Password",
  "html.profile.changePassword": "Change Password",
  "html.profile.recoveryPhrase": "Recovery Phrase",
  "html.profile.regenerate": "Regenerate",
  "html.profile.regenerateHint": "Generate a new 12-word recovery phrase. Your previous phrase (if any) stops working; your password is unaffected. Use this if you never saved a phrase or want to replace it.",
  "html.profile.encryptionKey": "Encryption Key",
  "html.profile.check": "Check",
  "html.profile.checkHint": "Checks that the key used to share maps with you matches your account, and repairs it if not.",
  "html.profile.staySignedIn": "Stay signed in on this device",
  "html.profile.staySignedInHint": "Keeps you signed in after closing the browser, so you only enter your password when you sign out. Your key is stored encrypted under a device key that this browser will not reveal to any website — including this one. Turn this off on shared or public computers.",
  "html.profile.forgetDevice": "Forget this device",
  "html.profile.forget": "Forget",
  "html.profile.forgetHint": "Erases the stored key from this browser. You stay signed in for now, but your password will be needed next time.",
  "html.profile.signOutEverywhere": "Sign out on all devices",
  "html.profile.signOutEverywhereButton": "Sign out everywhere",
  "html.profile.signOutEverywhereHint": "Signs this account out on every device, this one included. Signing out from the header signs out this device only.",
  "html.profile.dangerZone": "Danger Zone",
  "html.profile.deleteAccount": "Delete Account",
  "html.profile.deleteHint": "Permanently delete your account and all associated data. This action cannot be undone.",

  // Header. Key names (Ctrl, Shift, Z, G) stay as they are.
  "html.header.docProperties": "Document properties",
  "html.header.undo": "Undo (Ctrl+Z)",
  "html.header.redo": "Redo (Ctrl+Shift+Z)",
  "html.tabs.dashboard": "Dashboard",
  "html.tabs.bubbles": "Bubbles",
  "html.tabs.mindmap": "Mindmap",
  "html.tabs.routines": "Routines",
  "html.header.loginToSync": "Login to sync",
  "html.header.syncPausedTitle": "Click to refresh",
  "html.header.syncPaused": "Sync paused - refresh",
  "html.header.newProject": "New Project",

  // Import and export menus: the emoji is part of the text
  "html.import.json": "📄 Import JSON",
  "html.import.markdown": "📝 Import Markdown",
  "html.import.zip": "📦 Import ZIP (map or Markdown)",
  "html.export.json": "📄 Export JSON",
  "html.export.svg": "🖼️ Export SVG",
  "html.export.csv": "📊 Export CSV",
  "html.export.markdown": "📝 Export Markdown",
  "html.export.pdf": "📄 Export PDF",
  "html.export.html": "🌐 Export HTML",
  "html.export.zip": "📦 Export Markdown ZIP",
  "html.export.latex": "📐 Export LaTeX",

  // Theme menu ("Nord" is a name and is not translated)
  "html.header.changeTheme": "Change theme",
  "html.theme.light": "Light",
  "html.theme.dark": "Dark",
  "html.theme.sepia": "Sepia",

  // Header: notifications and account
  "html.header.notifications": "Notifications",
  "html.header.login": "Login",
  "html.header.offline": "Offline",
  "html.header.signOut": "Sign out",
  "html.header.logout": "Logout",

  // Sidebar: vault button, search, structure, tags
  "html.sidebar.openVault": "Open vault",
  "html.vault.title": "Vault",
  "html.sidebar.vaultHint": "Maps & folders",
  "html.search.region": "Search this map",
  "html.search.placeholder": "Search titles & notes…",
  "html.search.inputLabel": "Search node titles and notes",
  "html.search.clear": "Clear search",
  "html.search.previousTitle": "Previous result (Ctrl+Shift+G)",
  "html.search.previous": "Previous result",
  "html.search.nextTitle": "Next result (Ctrl+G)",
  "html.search.next": "Next result",
  "html.search.results": "Matching tasks",
  "html.sidebar.structure": "Structure",
  "html.sidebar.expandSpacing": "Expand spacing",
  "html.sidebar.verticalSpacing": "Vertical spacing",
  "html.sidebar.compactSpacing": "Compact spacing",
  "html.sidebar.tagsPaneResize": "Drag to resize Structure and Tags; arrow keys also adjust",
  "html.sidebar.tagsPaneHeight": "Tags pane height",
  "html.sidebar.addTag": "+ Add tag",
  "html.shortcuts.openTitle": "Keyboard shortcuts (?)",
  "html.shortcuts.title": "Keyboard shortcuts",
  "html.sidebar.toggle": "Toggle sidebar",

  // Mindmap view controls
  "html.mindmap.reset": "Reset View and Layout",
  "html.mindmap.gapUp": "Increase vertical gap",
  "html.mindmap.gapValue": "Vertical gap (% of node height)",
  "html.mindmap.gapDown": "Decrease vertical gap",

  // Node properties dialog
  "html.node.details": "Details",
  "html.node.namePlaceholder": "Enter name...",
  "html.node.parent": "Parent",
  "html.node.statusTags": "Status & tags",
  "html.node.planning": "Planning",
  "html.node.estimate": "Duration estimate",
  "html.node.estimateUnit": "Estimate unit",
  "html.node.days": "Days",
  "html.node.weeks": "Weeks",
  "html.node.months": "Months",
  "html.node.plannedStart": "Planned start",
  "html.node.plannedEnd": "Planned end",
  "html.node.appearance": "Appearance",
  "html.node.color": "Color",
  "html.node.applyToChildren": "Apply to children",
  "html.node.custom": "Custom:",
  "html.node.resetToParent": "Reset to parent",

  // Vault panel
  "html.vault.subtitle": "A home for everything you’re working on.",
  "html.vault.searchPlaceholder": "Search maps and folders…",
  "html.vault.searchLabel": "Search maps and folders",

  // Keyboard shortcuts dialog
  "html.shortcuts.close": "Close keyboard shortcuts",
  "html.shortcuts.intro": "Hover over or select a node to act on it. While typing, keys belong to the text editor.",
  "html.shortcuts.searchPlaceholder": "Find an action or key…",
  "html.shortcuts.searchLabel": "Search keyboard shortcuts",
  "html.shortcuts.empty": "No shortcuts match your search.",
};
